export enum FeatureFlagsEnum {
  WebsiteBlog = 'WebsiteBlog',
  Diagnostics = 'Diagnostics',
}
